import React from 'react';
import Style from 'styles/components/func.module.scss';

const SectionBlock = ({ title, subTitle, items }) => {
  return (
    <section className={Style.storefunc}>
      <h2 className={Style.title}>{title}</h2>
      <h2 className={Style.subTitle}>{subTitle}</h2>
      <div className={Style.grid}>
        {items.map((item, index) => (
          <div key={index} className={Style.card}>
            <div className={Style.card__labelWrapper}>
              <img src={item.image} alt={item.title} className={Style.icon} />
              <h3 className={Style.cardTitle}>{item.title}</h3>
            </div>
            <p className={Style.description}>{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SectionBlock;
